var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonenumberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.57 19.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{fill:#dde4e7;}.cls-5{stroke:#a7b9c5;stroke-miterlimit:10;stroke-width:0.8px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 19.57,
    height: 19.66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,9.11V10.6A9.8,9.8,0,1,0,0,9.11"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -5.03,
    y: -4.94,
    width: 29.59,
    height: 29.59
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8.08,9.22a4.7,4.7,0,0,0,2.29,2.3c.11-.18.2-.35.29-.52a.47.47,0,0,1,.56-.24l2.74.63a.54.54,0,0,1,.43.4,2.16,2.16,0,0,1-2,2.78,7.13,7.13,0,0,1-6.22-3.42,6.87,6.87,0,0,1-1.1-3.84A2.14,2.14,0,0,1,7.82,5.24a.55.55,0,0,1,.41.45c.2.88.41,1.76.61,2.64A.48.48,0,0,1,8.55,9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonenumberIcon);
export default __webpack_public_path__ + "static/media/phonenumber-icon.a596877693b910bd8352b5e3f78b726d.svg";
export { ForwardRef as ReactComponent };